import useAutorun from 'bz-utilities/hooks/autorun';
import { inject, observer } from 'mobx-react';
import type ProviderStore from 'src/stores/provider-store';

interface IProps {
  providerStore?: ProviderStore;
}

const MitelChat = inject('providerStore')(
  observer<React.FC<IProps>>(({ providerStore }) => {
    useAutorun(() => {
      if (!providerStore!.isVHG) return;

      let script = document.createElement('script');
      script.type = 'text/javascript';
      script.src =
        'https://webchat.mitel.io/bootstrapper.js?accountid%3DMzEwZWJmOWEtNzk0YS00MWFjLTk4MWUtNTYxY2RhOWYyOWFh%26chatname%3DTlNDIEJvb2tpbmc%3D';
      document.head.appendChild(script);
    }, [providerStore]);

    return null;
  })
);

export default MitelChat;
